<template>
  <div class="KeepPlanModalGroup">
    <KeepPlanConfirmationModal v-model="subscriptionStore.isKeepPlanOpen" :loading="subscriptionStore.keepPlanLoading" @confirmed="subscriptionStore.keepSubscription" />

    <KeepPlanSuccessModal v-model="keepPlanSucceeded" />

    <ActionErrorModal v-model="keepPlanFailed" @retry="subscriptionStore.keepSubscription" />
  </div>
</template>

<script setup lang="ts">
import KeepPlanConfirmationModal from './KeepPlanConfirmationModal.vue';
import KeepPlanSuccessModal from './KeepPlanSuccessModal.vue';

const subscriptionStore = useSubscriptionStore();

const keepPlanSucceeded = useAutoOpen(() => subscriptionStore.keepPlanSuccess);
const keepPlanFailed = useAutoOpen(() => subscriptionStore.keepPlanError);
</script>

<style lang="scss">
@use 'assets/scss/theme' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-base {
  .KeepPlanModal {
    max-width: 480px;

    &-content {
      display: flex;
      flex-direction: column;
      gap: vars.$dimensions-d-8;
      align-items: center;
      margin-top: vars.$dimensions-d-6;
    }

    &-description {
      color: vars.$organisms-modal-contentmodal-text-color;
      @include text.text('md');
    }

    &-actions {
      display: flex;
      gap: vars.$dimensions-d-10;
      justify-content: center;
      align-items: baseline;
      flex-wrap: wrap;
    }
  }
}
</style>
